
const UrlService = {

  patchQuery (query) {
    this._update(url => {
      Object.entries(query).forEach(([ key, value ]) => url.searchParams.set(key, value))
    })
  },

  setQuery (query) {
    this._update(url => url.searchParams = new URLSearchParams(query))
  },

  _update (func) {
    const url = new URL(document.location)
    func(url)

    this._clean(url)
    history.replaceState(null, '', decodeURIComponent(url.toString()))
  },

  _clean (url) {
    const empty = [];
    for (let [ key, value ] of url.searchParams.entries()) {
      if (!value)
        empty.push(key)
    }

    empty.forEach(key => url.searchParams.delete(key))
  }
}

export default UrlService
